import { render, staticRenderFns } from "./LogJiuzheng.vue?vue&type=template&id=6c4fae62&scoped=true"
import script from "./LogJiuzheng.vue?vue&type=script&lang=js"
export * from "./LogJiuzheng.vue?vue&type=script&lang=js"
import style0 from "./LogJiuzheng.vue?vue&type=style&index=0&id=6c4fae62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4fae62",
  null
  
)

export default component.exports